module.exports = {
  ACCEPT_LANGUAGE: 'en-US', // "language-COUNTRY".
  ACCEPT_ENCODING: 'gzip, deflate, sdch',
  CONTENT_TYPE: 'application/x-www-form-urlencoded; charset=UTF-8',
};